import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {MenuItem, MENUS} from './menus.config';
import {User} from '../../models/user.interface';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidenavComponent {
  @Input() currentUser: User;
  @Output() sidenavToggle: EventEmitter<void> = new EventEmitter<void>();
  public menus: MenuItem[];
  public env: string = environment.env;

  constructor() {
    this.menus = MENUS;
  }

  public isShowMenuItem(menuItem: MenuItem): boolean {
    return this.isHasRoleAccess(menuItem);
  }

  public getIconPath(menuItem: MenuItem): string {
    return `/assets/vvcr-icons/${menuItem.icon}.svg`;
  }

  public onToggleClick(): void {
    this.sidenavToggle.emit();
  }

  private isHasRoleAccess(menuItem: MenuItem): boolean {
    const roleId: number = this.currentUser.role.value;
    const accessRoleIds: number[] = menuItem.access;
    return accessRoleIds.includes(roleId);
  }
}
